<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"
                placeholder="仓库编号、仓库名称"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadWarehouse'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="warehouseList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="编号" prop="code"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="类型" prop="typeCode">
        <template #default="{row}">
          <div>{{ row.typeCode | valueName('WAREHOUSE_TYPE') }}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 150 : 160" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
          <span v-else>操作</span>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="detail(row)" size="mini">详情</el-button>
          <el-button v-if="!readOnly" type="text" @click="edit(row)" size="mini">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteWarehouse(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <edit-warehouse-dialog :visible.sync="dialog.show"
                           :warehouse="dialog.warehouse"
                           :read-only="dialog.readOnly">
    </edit-warehouse-dialog>
  </div>
</template>

<script>
import EditWarehouseDialog from '@/views/warehouse/EditWarehouseDialog'
import { Warehouse } from '@/store/objdef/objectDef'
import authority from '@/utils/authority'

export default {
  name: 'WarehouseList',
  components: { EditWarehouseDialog },
  data () {
    return {
      loading: false,
      searchText: null,
      dialog: {
        show: false,
        readOnly: true,
        warehouse: new Warehouse()
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$store.dispatch('warehouse/all').finally(() => {
        this.loading = false
      })
    },
    add () {
      this.dialog.warehouse = new Warehouse()
      this.dialog.show = true
    },
    detail (warehouse) {
      this.dialog.readOnly = true
      this.dialog.warehouse = this.$_.cloneDeep(warehouse)
      this.dialog.show = true
    },
    edit (warehouse) {
      this.dialog.readOnly = false
      this.dialog.warehouse = this.$_.cloneDeep(warehouse)
      this.dialog.show = true
    },
    deleteWarehouse (warehouse) {
      this.$confirm(`确认删除仓库【${warehouse.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('warehouse/delete', warehouse.id).then(() => {
          this.$message.success('删除成功!')
        })
      }).catch(() => {
      })
    },
    exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
  },
  computed: {
    exportUrl () {
        return this.$baseUrl + 'api/downloadWarehouseTemplate'
      },
    warehouseList () {
      const list = this.$store.state.warehouse.warehouseList
      if (!this.searchText) return list

      return list.filter(warehouse => warehouse.name.indexOf(this.searchText) !== -1 || warehouse.code.indexOf(this.searchText) !== -1)
    },
    readOnly () {
      return !this.$hasPermission(authority.WAREHOUSE)
    },
    addable () {
      return this.$hasPermission(authority.WAREHOUSE)
    },
    deletable () {
      return this.$hasPermission(authority.WAREHOUSE)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}
</style>
